'use client'

import GenericTaskFlow from './GenericTaskFlow'
import type { TaskFlowPhase, TaskFlowRequest } from '@/lib/task-flow/taskFlowStore'

export default function SynBuildFunnelFlow({
  request,
  phase,
}: {
  request: TaskFlowRequest
  phase: TaskFlowPhase
}) {
  return <GenericTaskFlow request={request} phase={phase} />
}